import { ChangeEvent } from 'react';
import { MdDeleteForever } from 'react-icons/md';
import { Button } from '../../../../../../components/button/button';
import { Container } from '../../../../../../components/container/container';
import { ExtendableBlock } from '../../../../../../components/extendable-block/extendable-block';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { Input } from '../../../../../../components/input/input';
import { MaskedInput } from '../../../../../../components/input/masked-input';
import { Modal, ModalProps } from '../../../../../../components/modal/modal';
import { LangInput } from '../../../../../../features/lang-input/lang-input';
import { phoneMask } from '../../../../../../helpers/regexp';
import { BranchSocialsModal } from './branch-socials-modal/branch-socials-modal';
import s from './create-branch-modal.module.css';
import { useCreateBranchModal } from './use-create-branch-modal';
import { InlineInputs } from '../../../../../../components/inline-inputs/inline-inputs';
import { Checkbox } from '../../../../../../components/checkbox/checkbox';
import { hasService } from '../../../../../../helpers/local-storage';

// const paymentOptions: IdValue[] = [
//   {
//     id: 'card',
//     value: 'Банковской картой',
//   },
//   {
//     id: 'cash',
//     value: 'Наличными',
//   },
// ];

export const CreateBranchModal = (props: ModalProps) => {
  const {
    branch,
    handleChangeZip,
    isLoading,
    t,
    handleSubmit,
    setBranch,
    openSocials,
    toggleOpenSocials,
    managerProfile,
    handleAddSsid,
    handleDeleteSsid,
    handleChangeSsid,
    handleChangeIikoOrganizationId,
  } = useCreateBranchModal(props);

  return (
    <Modal
      {...props}
      className={s.feature}
      title={t(branch?.id ? 'Изменить данные филиала' : 'Добавить филиал')}
      withLang
    >
      <Container required label={t('Название')}>
        <LangInput
          value={branch?.name}
          onChange={(e) => setBranch((prev) => ({ ...prev, name: e }))}
          name="name"
        />
      </Container>

      <Container required label={t('Адрес')}>
        <LangInput
          value={branch?.address}
          onChange={(e) => setBranch((prev) => ({ ...prev, address: e }))}
          name="address"
        />
      </Container>

      <Container label={t('Телефон')}>
        <MaskedInput
          mask={phoneMask}
          name="phone"
          value={branch?.phone}
          onChange={(e) => setBranch((prev) => ({ ...prev, phone: e }))}
        />
      </Container>

      <Container label={t('Индекс')}>
        <Input value={branch?.zip || ''} onChange={handleChangeZip} />
      </Container>

      <Container label={t('Описание')}>
        <LangInput
          value={branch?.description}
          onChange={(e) => setBranch((prev) => ({ ...prev, description: e }))}
        />
      </Container>

      {hasService('iiko') && (
        <Container label="iiko organization ID">
          <Input value={branch?.iiko_organization_id} onChange={handleChangeIikoOrganizationId} />
        </Container>
      )}

      <Checkbox
        checked={!!branch?.is_wifi_check_enabled}
        onClick={() =>
          setBranch((prev) => ({ ...prev, is_wifi_check_enabled: !prev?.is_wifi_check_enabled }))
        }
        label="SSID"
      />
      <ExtendableBlock
        className={s.list}
        button={{
          variant: 'secondary',
          children: t('Добавить'),
          onClick: handleAddSsid,
          disabled: managerProfile?.role !== 'admin_head',
        }}
      >
        {branch?.ssid_whitelist?.map((ssid, index) => (
          <InlineInputs key={index} className={s.item}>
            <Input
              value={ssid}
              placeholder={t('Введите SSID сети')}
              onChange={(e: ChangeEvent<HTMLInputElement>) => handleChangeSsid(index, e)}
            />
            <IconButton variant="ghost" outline onClick={() => handleDeleteSsid(index)}>
              <MdDeleteForever />
            </IconButton>
          </InlineInputs>
        ))}
      </ExtendableBlock>

      {/* <MultiSelect
        label={t('Способы оплаты')}
        options={paymentOptions}
        value={paymentOptions.filter((item) => branch?.payment_methods?.includes(item.id))}
        onSelect={(e) =>
          setBranch((prev) => ({ ...prev, payment_methods: e.map((item) => item.id) }))
        }
      /> */}

      <Button onClick={toggleOpenSocials}>{t('Соц.сети и мессенджеры')}</Button>
      {openSocials && (
        <BranchSocialsModal
          socials={branch?.socials}
          onClose={toggleOpenSocials}
          onChangeSocials={(e) => setBranch((prev) => ({ ...prev, socials: e }))}
        />
      )}
      <div className={s.controls}>
        <Button onClick={props.onClose} disabled={isLoading} variant="secondary">
          {t('Отменить')}
        </Button>
        <Button onClick={handleSubmit} disabled={isLoading}>
          {t(branch?.id ? 'Изменить' : 'Добавить')}
        </Button>
      </div>
    </Modal>
  );
};
